import { createContext } from 'react';
import { Pergunta } from 'api/Assessor/duvidas';

interface ChatContext {
  setDuvida: (value: Pergunta | undefined) => void;
  updateDuvida: (changes: object) => void;
  duvidaAtual?: Pergunta;
}

export default createContext<ChatContext>({
  setDuvida: () => ({}),
  updateDuvida: () => ({}),
});
